import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { MONITORS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const MonitorAddBreadcrumb: React.FC = () => {
	const linkToAddMonitor = useNavigateToLink(MONITORS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
		params: { id: "new" },
	});

	return <BreadcrumbLayout label="Add new monitor" to={linkToAddMonitor} />;
};
